import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/razorPaySlice";

import razorPayApis from "src/api/razorPay";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

const RazorPayOrderIdSaga = function* RazorPayOrderIdSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      razorPayApis.razorpayOrderId,
      payload
    );
    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response.message);
    }
    yield put(actions.razorPayOrderIdSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.razorPayOrderIdError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* razorPaySaga() {
  yield all([takeEvery(actions.razorPayOrderIdRequest, RazorPayOrderIdSaga)]);
}
